import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
export function App() {
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/terms" element={<TermsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </HashRouter>;
}